import { SelectionAny } from './internal';
export class SelectionMultimediaFormat extends SelectionAny {
    getMediaType() {
        return this.get("TYPE" /* Tag.Type */);
    }
}
//# sourceMappingURL=SelectionMultimediaFormat.js.map